import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import PromoBanner from '../components/PromoBanner';
import Hero from '../components/Hero';
import CategoryShowcase from '../components/CategoryShowcase';
import EarlyAccess from '../components/EarlyAccess';
import SafetyLab from '../components/SafetyLab';
import RiderCommunity from '../components/RiderCommunity';
import LocationLeadGen from '../components/LocationLeadGen';
import Footer from '../components/Footer';

const FAQ_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Where is Bikers Galleria located?",
      "acceptedAnswer": { "@type": "Answer", "text": "Bikers Galleria is located at Kunal Icon Rd, beside Saibaba Mandir, Pimple Saudagar, Pimpri-Chinchwad, Maharashtra 411027." }
    },
    {
      "@type": "Question",
      "name": "What are Bikers Galleria's opening hours?",
      "acceptedAnswer": { "@type": "Answer", "text": "We are open all 7 days from 10 AM to 9 PM." }
    },
    {
      "@type": "Question",
      "name": "Which helmet brands does Bikers Galleria stock?",
      "acceptedAnswer": { "@type": "Answer", "text": "We stock LS2, Axor, SMK, Raida, DSG, Solace, Blu Armor and many more premium motorcycle helmet brands." }
    },
    {
      "@type": "Question",
      "name": "Does Bikers Galleria offer shipping across India?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes. We offer free shipping across India on all orders." }
    },
    {
      "@type": "Question",
      "name": "Is Bikers Galleria an authorised dealer?",
      "acceptedAnswer": { "@type": "Answer", "text": "Yes, Bikers Galleria is an authorised dealer for LS2, Axor, and other top international and Indian motorcycle gear brands." }
    }
  ]
};

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Premium Motorcycle Riding Gear in Pune | Bikers Galleria</title>
        <meta name="description" content="Shop premium motorcycle helmets, jackets, gloves, boots & riding gear in Pimpri-Chinchwad, Pune. Authorised dealer for LS2, Axor, SMK, Raida & more. Open 7 days 10 AM–9 PM." />
        <link rel="canonical" href="https://www.bikersgalleria.com/" />
        <meta property="og:title" content="Premium Motorcycle Riding Gear in Pune | Bikers Galleria" />
        <meta property="og:description" content="Shop premium motorcycle helmets, jackets, gloves & riding gear in Pimpri-Chinchwad, Pune. Authorised dealer for LS2, Axor, SMK & more." />
        <meta property="og:url" content="https://www.bikersgalleria.com/" />
        <script type="application/ld+json">{JSON.stringify(FAQ_SCHEMA)}</script>
      </Helmet>
      <Header />
      <PromoBanner />
      <main>
        <Hero />
        <CategoryShowcase />
        <EarlyAccess />
        <SafetyLab />
        <RiderCommunity />
        <LocationLeadGen />
      </main>
      <Footer />
    </>
  );
};

export default Home;
